import { gql } from '@apollo/client';

import { LINE_ITEM_CUSTOM_PACING_FIELDS } from '../../../../../apis/graphql/common/fragments/lineItem/lineItemCustomPacingFields';

export const GET_LINE_ITEMS_V5_CAMPAIGN_MANAGER = gql`
  query getLineItemsV5CampaignManager($idList: [String!]!) {
    lineItemsV5CampaignManager(idList: $idList) {
      ...lineItemCustomPacingFields
    }
  }
  ${LINE_ITEM_CUSTOM_PACING_FIELDS}
`;
